<template>
  <div>
    <div class="users-layout">
        <default-box
        :loader="loading">
          <router-view/>
        <div class="d-flex justify-content-between align-items-center mb-10">
          <div></div>
          <router-link-to
              default_button
              :route_name="route_names.committee"
              :route_params="{id: 0}">
            {{ $t('committees.new') }}
          </router-link-to>
    </div>
    <tables-slot
    :empty_spacer="loading"
    @paginationFetch="fillData"
    @popstateEvent="fetchList"
    :pagination="pagination">
    <template v-slot:table_head>
        <td class="w-0 text-nowrap">#</td>
        <td class="w-0 text-nowrap">{{ $t('tables.title') }}</td>
      <td class="w-0 text-nowrap">{{ $t('committees.parent') }}</td>
        <td class="w-0 text-nowrap">{{ $t('committees.manager') }}</td>
        <td class="w-0 text-nowrap">{{ $t('committees.employees_count') }}</td>
        <td class="w-0 text-nowrap" v-if="getUserRoleIsAdmin">{{ $t('tables.edit') }}</td>
    </template>
    <template v-slot:table_body>
        <tr v-for="committee in committees">
            <td class="w-0 text-nowrap">
                {{ committee.id }}
            </td>
            <td class="w-0 text-nowrap">
                {{ committee.title }}
            </td>
            <td v-if="committee.parent" class="w-0 text-nowrap">
              <span class="fw-normal mb-1">{{ committee.parent.title }}</span>
            </td>
            <td v-else>
            </td>
            <td v-if="committee.manager && committee.manager.user" class="w-0 text-nowrap">
              <span class="fw-normal mb-1">{{ committee.manager.user?.name }}</span>
              <span class="text-muted mb-0">{{ committee.manager.user?.surname }}</span>
            </td>
            <td v-else class="w-0 text-nowrap">
              {{ $t('committees.no_manager') }}
            </td>
            <td class="w-0 text-nowrap">
              {{ committee.employees_count }}
            </td>
            <td class="w-0 text-nowrap">
              <span
                  @click="deleteCommittee(committee.id)"
                  class="d-inline-block px-10 py-10 cursor_pointer">
                <trash-icon/>
              </span>
                <router-link-to
                    class="d-inline-block px-10 py-10"
                :route_params="{id: committee.id}"
                :route_name="route_names.committee">
                <edit-icon/>
            </router-link-to>
        </td>
    </tr>
</template>
</tables-slot>
</default-box>

    </div>
  <notifier-block/>
  </div>
</template>

<script>

    import TablesSlot from "../small_components/tables/TablesSlot.vue";
    import DefaultBox from "../slots/DefaultBox.vue";
    import SearchInput from "../small_components/SearchInput.vue";
    import RouterLinkTo from "../small_components/RouterLinkTo.vue";
    import EditIcon from "../icons/EditIcon.vue";
    import Switcher from "../small_components/Switcher.vue";
    import AsideDashboard from "../small_components/AsideDashboard.vue";
    import HeaderBlock from "../parts/HeaderBlock.vue";
    import NotifierBlock from "../parts/NotifierBlock.vue";
    import {axiosArticles, axiosCommittees, axiosUsers} from "../../helpers/axios_requests";
    import calendar_mixin from "../../mixins/calendar_mixin";
    import routes_mixin from "../../mixins/routes_mixin";
    import TrashIcon from "../icons/TrashIcon.vue";

    export default {
      mixins: [calendar_mixin, routes_mixin],

      name: 'CommitteesLayout',
        components: {
          TrashIcon,
          NotifierBlock,
          HeaderBlock,
          AsideDashboard,
          Switcher,
          EditIcon,
          RouterLinkTo,
          SearchInput,
          DefaultBox,
          TablesSlot,

        },

      computed: {
      },
      beforeMount() {
      },

      data() {
        return {
          getUserRoleIsAdmin: true,
          loading: true,
          search: '',
          committees: [],
          pagination: [],
        }
      },

      created() {
        this.loading = false;
        this.fetchList()
      },
      methods: {
        searchFetchList() {
          return true;
        },

        fillData({collection, pagination}) {
          this.committees = collection || []
          this.pagination = pagination || []
        },

        fetchList() {
          this.loading = true
          axiosCommittees.list()
              .then(r => {
                this.fillData(r.data)
              })
              .finally(() => {
                this.loading = false
              })
        },
        deleteCommittee(id) {
          this.loading = true
          axiosCommittees.delete(id)
              .then(r => this.fetchList())
              .finally(() => {
                this.loading = false
              })
        }
      }
}
</script>
